import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { BASE_URL } from "../Pages/Config";

export default function Fotter() {
  const [email, setEmail] = useState("");
  const [category, setcategory] = useState([]); // ✅ FIXED
  const [CompanyDeatil, setCompanyDeatil] = useState([]);

  const [ads, setAds] = useState([]);
  const company = CompanyDeatil[0];
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter your email");
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}/footer_form.php`, {
        email: email.trim(),
      });

      if (res.data.success) {
        alert("Thank you for subscribing!");
        setEmail("");
      } else {
        alert(res.data.message || "Subscription failed");
      }
    } catch (error) {
      console.error(error);
      alert("Server error. Please try again later.");
    }
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_category.php?t=${Date.now()}`)
      .then((res) => {
        // console.log("Full response:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setcategory(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setcategory([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setcategory([]);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_company_detail.php?t=${Date.now()}`)
      .then((res) => {
        //   console.log("Full responsess:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setCompanyDeatil(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setCompanyDeatil([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setCompanyDeatil([]);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_ads.php?type=footer&t=${Date.now()}`)
      .then((res) => {
        //    console.log("Ads responsess :", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setAds(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setAds([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setAds([]);
      });
  }, []);

  const [currentAd, setCurrentAd] = useState(0);

  useEffect(() => {
    if (ads.length === 0) return;

    const interval = setInterval(() => {
      setCurrentAd((prev) => (prev + 1) % ads.length);
    }, 15000); // 15000ms = 15 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [ads]);

  const ad = ads[currentAd];

  return (
    <>
      <div className="container mb-5">
        <div className="row">
          <div className="col-12">
            <div className="advertisement" style={{ textAlign: "center" }}>
              {ads.length > 0 ? (
                <Link to={ad.link || "#"}>
                  <img
                    src={
                      `${BASE_URL}/uploads/ads/${ad.image}` ||
                      "/assets/default-ad.jpg"
                    }
                    alt={ad.title || "Advertisement"}
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      objectFit: "contain",
                      borderRadius: "2px",
                      transition: "opacity 0.5s ease-in-out",
                    }}
                  />
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="home1-footer-top-area">
          <div className="row g-4">
            <div className="col-lg-12">
              <div className="footer-top-banner">
                <div className="banner-content">
                  <h2>
                    <Link to="how-to-buy.html">Sign Up for the FastTrade</Link>
                  </h2>

                  <form className="form" onSubmit={handleSubmit}>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <input type="submit" value="Subscribe" />
                  </form>

                  <img
                    src="logo/mailicon.webp"
                    alt=""
                    className="footer-mail-icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-wrapper">
          <div className="container">
            <div className="footer-menu-wrap">
              <div className="row g-lg-4 gy-5">
                <div className="col-lg-2 col-sm-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h4>Category</h4>
                    </div>
                    <div className="menu-container">
                      <ul className="widget-list">
                        {category.length > 0 ? (
                          category.slice(0, 6).map((cat, index) => (
                            <li key={index}>
                              <Link to={`/category/${cat.title}`}>
                                {cat.title}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li>No categories available</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-2 col-sm-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h4>Company</h4>
                    </div>
                    <div className="menu-container">
                      <ul className="widget-list">
                        <li>
                          <Link to="/howtobid">How to Sell/Bid with us</Link>
                        </li>
                        <li>
                          <Link to="/charges_info">Charges Info</Link>
                        </li>
                        <li>
                          <Link to="/about-us">About us</Link>
                        </li>
                        <li>
                          <Link to="/faq">F.A.Q</Link>
                        </li>
                        <li>
                          <Link to="/help">Help</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-sm-6 d-flex align-items-center justify-content-lg-center justify-content-start">
                  <div className="footer-logo-area">
                    <div className="footer-logo">
                      <Link to="/">
                        <img
                          src={`${BASE_URL}/images/fastrade_logo.jpg`}
                          alt="Fast Trade "
                        />
                      </Link>
                    </div>
                    <div className="social-area">
                      <h5>Social Just You Connected Us!</h5>
                      <p>All of update in social</p>
                      {company && (
                        <ul className="social-list">
                          {company.linkdin && (
                            <li>
                              <a
                                href={company.linkdin}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="bi bi-linkedin"></i>
                                <span>LinkedIn</span>
                              </a>
                            </li>
                          )}
                          {company.facebook && (
                            <li>
                              <a
                                href={company.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="bi bi-facebook"></i>
                                <span>Facebook</span>
                              </a>
                            </li>
                          )}
                          {company.twitter && (
                            <li>
                              <a
                                href={company.twitter}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="bi bi-twitter-x"></i>
                                <span>Twitter</span>
                              </a>
                            </li>
                          )}
                          {company.instagram && (
                            <li>
                              <a
                                href={company.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="bi bi-instagram"></i>
                                <span>Instagram</span>
                              </a>
                            </li>
                          )}
                          {company.google_plus && (
                            <li>
                              <a
                                href={company.google_plus}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="bi bi-youtube"></i>
                                <span>YouTube</span>
                              </a>
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-sm-6 d-flex justify-content-sm-end justify-content-start">
                  <div
                    className="app-promo-wrap text-center text-sm-end p-4 rounded-4 "
                    style={{
                      color: "#000000ff",
                    }}
                  >
                    <h4
                      className="fw-bold mb-2"
                      style={{ textAlign: "center" }}
                    >
                      Get the FastTrade App
                    </h4>
                    <p
                      className="small mb-4"
                      style={{ opacity: 0.9, textAlign: "center" }}
                    >
                      Buy, sell, and bid anytime, anywhere. Stay updated with
                      real-time alerts and exclusive deals — only on our mobile
                      app.
                    </p>

                    <div className=" gap-2  justify-content-center flex-wrap" style={{ justifyContent: "center" , display:"none"}}>
                      <a
                        href="#"
                        className="store-btn d-flex align-items-center bg-dark text-light px-3 py-2 rounded-3 text-decoration-none shadow"
                      >
                        <i className="bi bi-google-play fs-4 me-2 text-success"></i>
                        <div className="text-start">
                          <small className="d-block lh-1">GET IT ON</small>
                          <strong>Google Play</strong>
                        </div>
                      </a>

                      <a
                        href="#"
                        className="store-btn d-flex align-items-center bg-dark text-light px-3 py-2 rounded-3 text-decoration-none shadow"
                      >
                        <i className="bi bi-apple fs-3 me-2"></i>
                        <div className="text-start">
                          <small className="d-block lh-1">
                            Download on the
                          </small>
                          <strong>App Store</strong>
                        </div>
                      </a>
                    </div>

                    <div
                      className="mt-4 text-dark small"
                      style={{
                        opacity: 0.9,
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <i className="bi bi-shield-check me-1"></i> 100% secure •
                      <i className="bi bi-lightning-charge-fill mx-1"></i>{" "}
                      Instant access •<i className="bi bi-bell-fill mx-1"></i>{" "}
                      Real-time notifications
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-bottom">
              <div className="copyright-area">
                <p>
                  All rights reserved ©Copyright 2025{" "}
                  <Link to="">FastTrade</Link>
                </p>
              </div>
              <div className="footer-bottom-right">
                <ul>
                  <li>
                    <Link to="/customerCare">Support Center</Link>
                  </li>
                  <li>
                    <Link to="/terms-condition">Terms &amp; Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
